<template>
  <div style="text-align: center;margin-bottom: 600px">
    智慧城市
  </div>
</template>

<script>
export default {
  name: "city",
  components: {
  },
  data() {
    return {

    };
  },
  created() {},

  mounted() {

  }
};
</script>

<style lang="scss" scoped>

</style>